import { render, staticRenderFns } from "./InfoAccreditations.vue?vue&type=template&id=511ff182&"
import script from "./InfoAccreditations.vue?vue&type=script&lang=js&"
export * from "./InfoAccreditations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports